import * as React from 'react';
import Select, { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	PaginationOrderHow,
	useTermItemsQuery,
} from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import { useMemo, useState } from 'react';
import Loading from '../../../../Components/Loading';
import useTranslation from '../../../../Hooks/useTranslation';
import useSelectValueGuard from '../../../Base/Hooks/useSelectValueGuard';

interface Props {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
	includeSelfPayer?: boolean;
	isClearable?: boolean;
}

export const SELF_PAYER_VALUE = 'selfPaid';

const HealthInsuranceCompanySelect: React.FC<Props> = props => {
	const { value, onChange, includeSelfPayer, isClearable = true } = props;
	const { data, isLoading } = useTermItemsQuery({
		termType: 'insurance_companies',
		pagination: {
			take: 999,
			order: { key: 'value', how: PaginationOrderHow.Asc },
		},
	});
	const [defaultValue, setDefaultValue] = useState(value);
	const { t } = useTranslation();

	const options: SelectValue[] = useMemo(() => {
		const items: SelectValue[] = [];

		if (includeSelfPayer) {
			items.push({
				value: SELF_PAYER_VALUE,
				label: t('component.laboratoryRequestCreateRecapitulation.selfPaid'),
			});
		}

		for (const termItem of data?.termItems?.data || []) {
			if (termItem) {
				items.push({
					value: termItem.id,
					label: termItem.value + ' - ' + termItem.value2,
				});
			}
		}

		return items;
	}, [data, includeSelfPayer]);

	useSelectValueGuard({ options, value, onChange });

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Select
			options={options}
			{...props}
			onChange={onChange}
			placeholder={t('base.shared.pick')}
			value={defaultValue?.label ? defaultValue : value}
			isClearable={isClearable}
		/>
	);
};

export default HealthInsuranceCompanySelect;
